import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useUser } from "../../user/utils/user";

import { useRoleClientSelection } from "../contexts/RoleClientSelectionContext";
import { resolveRoute } from "../utils/routeHelpers";

function Home() {
  const navigate = useNavigate();
  const { user } = useUser();
  const { setSelection } = useRoleClientSelection();

  useEffect(() => {
    const defaultRole = "Data";
    const defaultClient = "ocp";

    // Scenario 1: User is logged out OR logged in but has NO role_clients assigned
    if (
      !user ||
      !user.user ||
      !user.user.role_clients ||
      user.user.role_clients.length === 0
    ) {
      setSelection(defaultRole, defaultClient);
      const targetPath = resolveRoute("/task", {
        role: defaultRole,
        client: defaultClient,
      });
      navigate(targetPath);
      return;
    }

    // Scenario 2: User is logged in and has role_clients
    if (user && user.user && user.user.role_clients) {
      const roleClients = user.user.role_clients;

      // Case 2a: Exactly one role-client pair.
      if (roleClients.length === 1) {
        const { role_name, client_name } = roleClients[0];
        setSelection(role_name, client_name);
        // Build path explicitly
        const targetPath = resolveRoute("/task", {
          role: role_name,
          client: client_name,
        });
        navigate(targetPath);
        return;
      }

      // Case 2b: Multiple role-client pairs.
      if (roleClients.length > 1) {
        const uniqueRoles = [...new Set(roleClients.map((rc) => rc.role_name))];

        if (uniqueRoles.length === 1) {
          // Only one role, multiple clients
          setSelection(uniqueRoles[0], null);
          navigate("/clients");
        } else {
          // Multiple roles
          setSelection(null, null);
          navigate("/roles");
        }
        return;
      }
    }
  }, [user, navigate, setSelection]);

  return null;
}

export default Home;
